/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
( ( { hooks: { addFilter: addFilterBe } }, { hooks: { addFilter: addFilterFe } } ) => {
} )( wp, feWp );


